export default "__VITE_ASSET__B6k67SyP__"